export default function ArrowDownIcon({
  width = 8,
  height = 6,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33334 1.11378C7.20843 0.989616 7.03946 0.919922 6.86334 0.919922C6.68722 0.919922 6.51825 0.989616 6.39334 1.11378L4.00001 3.47378L1.64001 1.11378C1.5151 0.989616 1.34613 0.919922 1.17001 0.919922C0.993883 0.919922 0.824915 0.989616 0.700006 1.11378C0.637521 1.17576 0.587925 1.24949 0.554079 1.33073C0.520233 1.41197 0.502808 1.49911 0.502808 1.58712C0.502808 1.67512 0.520233 1.76226 0.554079 1.8435C0.587925 1.92474 0.637521 1.99847 0.700006 2.06045L3.52667 4.88712C3.58865 4.9496 3.66238 4.9992 3.74362 5.03304C3.82486 5.06689 3.912 5.08432 4.00001 5.08432C4.08801 5.08432 4.17515 5.06689 4.25639 5.03304C4.33763 4.9992 4.41136 4.9496 4.47334 4.88712L7.33334 2.06045C7.39582 1.99847 7.44542 1.92474 7.47927 1.8435C7.51311 1.76226 7.53054 1.67512 7.53054 1.58712C7.53054 1.49911 7.51311 1.41197 7.47927 1.33073C7.44542 1.24949 7.39582 1.17576 7.33334 1.11378Z"
        fill={color}
      />
    </svg>
  );
}
